import { CartStack } from '@/modules/external/components/customer/cart/cart-stack.component.tsx';
import { CartItemsCard } from '@/modules/external/components/customer/cart/cart-items-card.component.tsx';
import { CartDeliveryAddressCard } from '../../components/customer/cart/confirm/cart-delivery-address.component';
import { CartRemarksCard } from '../../components/customer/cart/cart-remarks-card.component';
import { CartConfirmSummaryCard } from '../../components/customer/cart/confirm/cart-confirm-summary-card.component';
import { CartShippingTypeCard } from '../../components/customer/cart/cart-shipping-type-card.component';

export function ExternalCartConfirmPage() {
  return (
    <CartStack>
      <CartItemsCard />
      <CartDeliveryAddressCard />
      <CartRemarksCard />
      <CartShippingTypeCard />
      <CartConfirmSummaryCard />
    </CartStack>
  );
}
